<template>
<div>
    <v-container fill-height class="pt-8" style="max-width: 1098px;">
        <!-- <v-row>
            <img width="250" class="ma-7" src="PDC.png" />
        </v-row> -->
        <v-row>
            <v-toolbar flat class="mb-2">
                <v-toolbar-title>Submission Form for Part 1 - UofA Consultant Data Sheet</v-toolbar-title>
                <v-divider class="mx-4"></v-divider>
            </v-toolbar>
        </v-row>
        <v-row>
            <v-col>
                <v-row>
                  
                        <v-card flat class="pa-6">
                            <v-card-text>
                                <v-form v-model="valid">
                                    
                                    <v-row dense justify="space-between" align="center" >
                                        <v-col>
                                            <v-text-field :rules="nameRules" v-model="selectedARQ.company_name" label="Company Name"></v-text-field>
                                        </v-col>
                                        <v-col align="end">
                                            
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col md="12" sm="12" lg="6"><v-text-field :rules="streetRules" v-model="selectedARQ.company_street" label="Street"></v-text-field></v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col md="4" sm="4" lg="4"><v-text-field :rules="cityRules" v-model="selectedARQ.company_city" label="City"></v-text-field></v-col>
                                        <v-col md="4" sm="4" lg="4"><v-text-field :rules="stateRules" v-model="selectedARQ.company_state" label="State"></v-text-field></v-col>
                                        <v-col md="4" sm="4" lg="4"><v-text-field :rules="zipRules" v-model="selectedARQ.company_zip" label="Zip"></v-text-field></v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="6">
                                            <v-text-field :rules="phoneRules" v-model="selectedARQ.company_phone" label="Phone"></v-text-field>
                                        </v-col>
                                        <v-col cols="6"><v-text-field :rules="emailRules" v-model="selectedARQ.email" label="Email"></v-text-field></v-col>
                                        <!-- <v-col cols="6">
                                            <v-text-field v-model="selectedARQ.company_fax" label="Fax"></v-text-field>
                                        </v-col> -->
                                    </v-row>
                                    <v-row dense>
                                        <v-col><v-text-field :rules="partnerRules" v-model="selectedARQ.company_partner_names" label="Partners"></v-text-field></v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col><v-text-field :rules="contactRules" v-model="selectedARQ.contact_person" label="Contact"></v-text-field></v-col>
                                    </v-row>

                                    <v-col>
                                        <v-checkbox v-model="selectedARQ.small_business" label="Small Business"></v-checkbox>
                                        <h4>
                                            For purposes of this document and as stated in A.R.S. § 41-1001 (19), a small business is defined as a concern, including its affiliates, which is independently owned and operated, which is not dominant in its field and which employs fewer than one hundred full-time employees or which had gross annual receipts of less than four million dollars in its last fiscal year. For purposes of a specific rule, an agency may define small business to include more persons if it finds that such a definition is necessary to adapt the rule to the needs and problems of small businesses and organizations
                                        </h4>
                                    </v-col>    
                                    

                                    <v-row class="mt-4">
                                        <v-col><h3>I. Disciplines</h3><v-divider></v-divider></v-col>
                                    </v-row>
                                    <v-row no-gutters class="topOverride">
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ae"
                                                label="Acoustical Engineering"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_a"
                                                label="Architect"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ce"
                                                label="Civil Engineering"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_cs"
                                                label="Commissioning Services"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_cr"
                                                label="Constructability Review"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ca"
                                                label="Construction Administration"
                                            ></v-checkbox>
                                        </v-col>
                                    
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ci"
                                                label="Construction Inspection"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ctrl"
                                                label="Control Engineering"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_dm"
                                                label="Digital Mapping Specialist"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ee"
                                                label="Electrical Engineer"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ea"
                                                label="Environmental Assessment"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_fpe"
                                                label="Fire Protection Engineer"
                                            ></v-checkbox>
                                        </v-col>
                                    
                                    
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_gis"
                                                label="GIS"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_gss"
                                                label="Geo-Spacial Systems Consultant"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_geo"
                                                label="Geotechnical Engineer"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_hw"
                                                label="Hazardous Waste"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_int"
                                                label="Interior Design"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_lp"
                                                label="Land Planner"
                                            ></v-checkbox>
                                        </v-col>
                                    
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ls"
                                                label="Land Surveying"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_la"
                                                label="Landscape Architecture"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_leed"
                                                label="LEED"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_mat"
                                                label="Materials Engineer"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_me"
                                                label="Mechanical Engineer"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_pc"
                                                label="Parking Consultant"
                                            ></v-checkbox>
                                        </v-col>
                                    
                                   
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ph"
                                                label="Photogrammetry"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_prg"
                                                label="Program/Space Planning"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_pe"
                                                label="Project Estimating"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_sp"
                                                label="Specifications"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_se"
                                                label="Structural Engineering"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_tel"
                                                label="Telecommunications"
                                            ></v-checkbox>
                                        </v-col>
                                    
                                    
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.discipline_ve"
                                                label="Value Engineering"
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>

                                      <v-row class="mt-4">
                                        <v-col><h3>II. Experience Epmhasis</h3><v-divider></v-divider></v-col>
                                    </v-row>

                                    <v-row no-gutters class="topOverride">
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ada"
                                                label="ADA Compliance"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ag"
                                                label="Agriculture Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ath"
                                                label="Athletic Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_av"
                                                label="Audio/Visual Systems"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_aud"
                                                label="Auditorium/Theater"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ben"
                                                label="Building Envelope"
                                            ></v-checkbox>
                                        </v-col>
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_bmo"
                                                label="Building Modeling"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_bsu"
                                                label="Building Surveying"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_cr"
                                                label="Clean Rooms"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ca"
                                                label="Code Assessment"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ci"
                                                label="Construction Inspection"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_dc"
                                                label="Digital Cartography"
                                            ></v-checkbox>
                                        </v-col>
                                   
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_elev"
                                                label="Elevators"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_fp"
                                                label="Facilities Programming"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_fe"
                                                label="Feasibility Studies"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_fs"
                                                label="Food Service"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_gc"
                                                label="General Classroom"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_gis"
                                                label="GIS Database Development"
                                            ></v-checkbox>
                                        </v-col>
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_hw"
                                                label="Hazardous Waste Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_hc"
                                                label="Historic Preservation"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_int"
                                                label="Interior Design"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_lp"
                                                label="Land Planning"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ld"
                                                label="Landscape Design"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_lib"
                                                label="Libraries"
                                            ></v-checkbox>
                                        </v-col>
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_mnt"
                                                label="Maintenance Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_mp"
                                                label="Master Planning"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_mat"
                                                label="Materials Testing"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_med"
                                                label="Medical Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_mus"
                                                label="Museums"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_mf"
                                                label="Music Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_obs"
                                                label="Observatories"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_of"
                                                label="Office Facilities"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_or"
                                                label="Outdoor Recreation"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ps"
                                                label="Parking Structures"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ph"
                                                label="Photo Surveying"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_rec"
                                                label="Recreation Activities"
                                            ></v-checkbox>
                                        </v-col>
                                   
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_rr"
                                                label="Renovation/Remodel"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_rfg"
                                                label="Reroofing"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_rl"
                                                label="Research Labs"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_rh"
                                                label="Residence Halls"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_ret"
                                                label="Retail"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_sg"
                                                label="Signange/Graphics"
                                            ></v-checkbox>
                                        </v-col>
                                  
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_sp"
                                                label="Site Planning/Design"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_soil"
                                                label="Soils Investigation"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_si"
                                                label="Special Inspection"
                                            ></v-checkbox>
                                        </v-col>
                                          <v-col md="4" lg="2" sm="12" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_tl"
                                                label="Teaching Labs"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_te"
                                                label="Traffic Engineering"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_util"
                                                label="Utilities"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col md="4" sm="12" lg="2" xl="2" >
                                            <v-checkbox
                                                v-model="selectedARQ.experience_web"
                                                label="Web Map Application Development"
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>

                                      <v-row class="mt-4">
                                        <v-col><h3>III. Arizona Professional Licenses</h3><v-divider></v-divider></v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12"><h4>Please check if your firm has professional(s) licensed in Arizona and indicate how many individuals for each discipline.
                                            The University of Arizona requires professionals to be licensed in the State of Arizona. Arizona licenses/registrations will be verified.
                                        </h4>
                                        </v-col>
                                    </v-row>

                                 
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_architecture" label="Architecture"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_architecture_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                  
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_civil" label="Civil"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_civil_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_electrical" label="Electrical"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_electrical_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_landscape" label="Landscape"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_landscape_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_mechanical" label="Mechanical"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_mechanical_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_structural" label="Structural"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_structural_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_survey" label="Survey"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_survey_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                        <v-row no-gutters dense>
                                            <v-col sm="6" lg="3" xl="2"><v-checkbox v-model="selectedARQ.license_other" label="Other"></v-checkbox></v-col>
                                            <v-col sm="6" lg="3" xl="3"><v-text-field :rules="licenseIndividualsRules" v-model="selectedARQ.license_other_number" label="Number of individuals"></v-text-field></v-col>
                                        </v-row>
                                    
                                    <v-col sm="12" lg="6" xl="6">
                                        <v-text-field :rules="licenseOtherRules" v-model="selectedARQ.license_other_type" label="Other licenses"></v-text-field>
                                    </v-col>

                                     <v-row class="mt-4">
                                        <v-col><h3>IV. Insurance</h3><v-divider></v-divider></v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col md="6" sm="12">
                                            <v-text-field :rules="insuranceRules" v-model="selectedARQ.insurance_auto_amount" label="Auto Amount ($)"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                      
                                        <v-col md="6" sm="12">
                                            <v-text-field :rules="insuranceRules" v-model="selectedARQ.insurance_professional_amount" label="Professional Amount ($)"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                       
                                        <v-col md="6" sm="12">
                                            <v-text-field :rules="insuranceRules" v-model="selectedARQ.insurance_workman_amount" label="Workman's Amount ($)"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                       
                                        <v-col md="6" sm="12">
                                            <v-text-field :rules="insuranceRules" v-model="selectedARQ.insurance_comprehensive_amount" label="Comprehensive Amount ($)"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>   
                                        <v-col md="6" sm="12">
                                            <v-checkbox v-model="selectedARQ.insurance_can_be_increased" label="Can these be increased?"></v-checkbox>
                                        </v-col>
                                    </v-row>

                                   
                                </v-form>
                            </v-card-text>
                            
                        </v-card>
                    <v-row align="center" justify="end">
                        <v-btn min-width="150" class="mr-5 ml-10 mb-5" @click="saveChanges" color="primary" :loading="loading">SUBMIT</v-btn>
                    </v-row>
            </v-row>
            </v-col>
        </v-row> 
        

       
    </v-container>
    
</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    name: 'ARQEntry',

    data() {
        return {
            loading: false,
            selectedARQ:  {
            "arq_contact_id": 0,
            "vendor_id": null,
            "open_end": false,
            "vendor_name": "",
            "company_name": "",
            "company_street": "",
            "company_city": "",
            "company_state": "",
            "company_zip": "",
            "company_fax": "",
            "company_phone": "",
            "email": "",
            "company_partner_names": "",
            "contact_person": "",
            "discipline_ae": false,
            "discipline_a": false,
            "discipline_ce": false,
            "discipline_cs": false,
            "discipline_cr": false,
            "discipline_ca": false,
            "discipline_ci": false,
            "discipline_ee": false,
            "discipline_geo": false,
            "discipline_ls": false,
            "discipline_la": false,
            "discipline_mat": false,
            "discipline_me": false,
            "discipline_pc": false,
            "discipline_ph": false,
            "discipline_prg": false,
            "discipline_pe": false,
            "discipline_sp": false,
            "discipline_se": false,
            "discipline_tel": false,
            "discipline_ve": false,
            "experience_ada": false,
            "experience_ag": false,
            "experience_ath": false,
            "experience_aud": false,
            "experience_cr": false,
            "experience_ci": false,
            "experience_elev": false,
            "experience_fp": false,
            "experience_fe": false,
            "experience_fs": false,
            "experience_gc": false,
            "experience_hc": false,
            "experience_hs": false,
            "experience_ld": false,
            "experience_lib": false,
            "experience_mnt": false,
            "experience_mp": false,
            "experience_mat": false,
            "experience_med": false,
            "experience_mus": false,
            "experience_mf": false,
            "experience_of": false,
            "experience_or": false,
            "experience_ps": false,
            "experience_ph": false,
            "experience_rec": false,
            "experience_rr": false,
            "experience_rfg": false,
            "experience_rl": false,
            "experience_rh": false,
            "experience_sg": false,
            "experience_sp": false,
            "experience_soil": false,
            "experience_si": false,
            "experience_tl": false,
            "experience_te": false,
            "experience_util": false,
            "license_architecture": false,
            "license_architecture_number": "",
            "license_civil": false,
            "license_civil_number": "",
            "license_electrical": false,
            "license_electrical_number": "",
            "license_landscape": false,
            "license_landscape_number": "",
            "insurance_auto_amount": null,
            "insurance_professional_amount": "",
            "insurance_workman_amount": "",
            "insurance_can_be_increased": false,
            "comments": null,
            "fdc_accepted": false,
            "insurance_comprehensive_amount": "",
            "license_mechanical": false,
            "license_mechanical_number": "",
            "license_structural": false,
            "license_structural_number": "",
            "license_survey": false,
            "license_survey_number": "",
            "license_other": false,
            "license_other_number": "",
            "ip_address": null,
            "small_business": false,
            "discipline_hw": false,
            "experience_hw": false,
            "experience_obs": false,
            "closed": false,
            "discipline_ctrl": false,
            "discipline_dm": false,
            "discipline_ea": false,
            "discipline_fpe": false,
            "discipline_gis": false,
            "discipline_gss": false,
            "discipline_lp": false,
            "discipline_leed": false,
            "experience_av": false,
            "experience_ben": false,
            "experience_bmo": false,
            "experience_bsu": false,
            "experience_ca": false,
            "experience_dc": false,
            "experience_gis": false,
            "experience_lp": false,
            "experience_ret": false,
            "experience_web": false,
            "license_other_type": "",
            "discipline_int": false,
            "experience_int": false
        },
            loading: false,
            valid: false,
            requiredRule: [
              value => !!value || 'Required.',
            ],
            nameRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 128 || 'Max 128 characters',
            ],
            cityRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 50 || 'Max 50 characters',
            ],
            stateRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 2 || 'Max 2 characters',
            ],
            streetRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 50 || 'Max 50 characters',
            ],
            insuranceRules: [
                value => (value || '').length <= 25 || 'Max 25 characters',
            ],
            licenseIndividualsRules: [
                value => (value || '').length <= 25 || 'Max 25 characters',
            ],
            licenseOtherRules: [
                value => (value || '').length <= 128 || 'Max 128 characters',
            ],
            contactRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 128 || 'Max 128 characters',
            ],
            partnerRules: [
                value => (value || '').length <= 128 || 'Max 128 characters',
            ],
            zipRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 50 || 'Max 50 characters',
            ],
            phoneRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 50 || 'Max 50 characters',
            ],
            emailRules: [
                value => !!value || 'Required.',
                value => (value || '').length <= 128 || 'Max 128 characters',
            ],
        }
    },

    watch: {
  
    },

    computed: {


    },

    async mounted(){
        
    },

    methods: {
        ...mapActions(['newARQ']),
        ...mapMutations(['setSnackText']),

    

        async saveChanges(){
             if (!this.valid) {
                 this.setSnackText("Required information missing or does not pass validation. Please correct and try again.");
                return;
              }

            this.loading = true
            let response = await this.newARQ(this.selectedARQ);

            if (response === 'Saved') {
                //this.setSnackText("Submission successful")
                top.location = "https://apps.ufs.arizona.edu/web/arq/arqpart2.aspx";
            }
            else {
                this.setSnackText("Submission could not be saved.")
            }
        },

    },
}
</script>

<style>
    .leftScroller {
        height: calc(100vh - 220px) !important;
        
        overflow-y: auto;
          /* width */
  
    }
    .arqFormScroller {
        height: calc(100vh - 220px) !important;
        
        overflow-y: auto;
          /* width */
  
    }

    .topOverride .v-input__slot {
        align-items: start;
    }
</style>